import { GridItem } from '../../../../models';
import { SearchGetterContext } from '../../search.interfaces';
import { GridItemsReducer } from './grid-items-reducer.interfaces';

export class ResultsReducer implements GridItemsReducer {
  reduce(gridItems: GridItem[], { state: { results } }: SearchGetterContext): GridItem[] {
    return gridItems.concat(results);
  }
}
